import * as charts from "../../charts/";
import { ChartType } from "../../entities/reportEntity";

export default {
  id: 25,
  label: "省市技术分类分析",
  chart: charts.lineAndBar2D,
  definition: {
    rowDims: [{ name: "miniIpc", label: "主分类小类", limit: 10, needTotal: true }],
    colDims: [{ name: "applicantProvince", label: "省", needTotal: true }],
    measures: [{ name: "count", label: "专利量", sortBy: "DESC" }],
    condition: {
      items: [{
        name: "applicantProvince",
        operator: "NOT_NULL"
      }, {
        name: "miniIpc",
        operator: "NOT_NULL"
      }]
    },
    showNoDataDims: true
  },
  chartOption: {
    chartType: ChartType.BAR,
    title: "省市技术分类分析",
    subTitle: "",
    hideTitle: false,
    xaxisTitle: "",
    yaxisTitle: "",
    hideAxisTitle: true,
    hideLabel: true,
    hideLegend: false,
    hideToolbox: false
  }
};
